import axios from "axios";
import {API} from "../constants";

export const getWarehouses = async (filters) => {
    let url = `${API.WAREHOUSES}`
    if (filters) {
        Object.entries(filters).forEach(([k, v]) => {
            url = url + `?${k}=${v}`
        })
    }
    return axios.get(url)
}

export const getAllWarehouses = async () => {
    return axios.get(`${API.WAREHOUSES}all/`)
}